import { useCommon } from '../../Hooks/Common/useCommon';
import { useServerDatabase } from '../../Hooks/Features/ServerDatabase/useServerDatabase';
import { Dialog } from "primereact/dialog";
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Autocomplete from '@mui/material/Autocomplete';
import { SkeletonDataTable } from "../../components/Loader/Loader.jsx";
import TextField from '@mui/material/TextField';
import { MuiCss } from '../../utils/Helper';
import _ from "underscore";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CommonFilterDropdown from '../CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx';

const ServerDatabase = () => {
    const { handleEdit, tagRef, enabelPopup, setEnabelpopup, option, filterValues, setFilterValues, rowData, loader, columns, handleUpsertServerdata, getServerData, dbInputs, setDbInputs, resetForm, handleDelete, isEditMode } = useServerDatabase();
    const { checkPermission } = useCommon();
    return (
        <div ref={() => checkPermission("serverdatabase", tagRef)}>
            <div ref={tagRef} id='{"tabname": "server_db_master", "data": "server_db_master_tab"}'  >
                <div className="row sk-header-row align-items-center mb-2">
                    <div className="col-md-6 col-12">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects", col: 3 },
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 d-flex justify-content-end gap-2 mt-2">
                        <button className="sk-btn-primary rounded" onClick={() => { getServerData() }}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                        <button className="button btn-primary rounded" onClick={() => setEnabelpopup(true)}><FontAwesomeIcon icon="fa-solid fa-plus" /></button>
                    </div>
                </div>
                <Dialog
                    visible={enabelPopup}
                    modal
                    draggable={false}
                    className="modal-small"
                    onHide={() => {
                        resetForm()
                        setEnabelpopup(false);
                    }}
                    header={isEditMode ? "Edit Server Database" : "Create Server Database"}>
                    <div className="w-100 mt-2">
                        <div className="mt-2">Project Name*</div>
                        <Dropdown className="input-dd w-100" placeholder="Project"
                            options={option.project || []}
                            optionLabel="project_name"
                            optionValue="project_id"
                            value={filterValues.project}
                            onChange={(e) => setFilterValues(prev => ({ ...prev, project: e.target.value }))}
                            filter filterInputAutoFocus
                            disabled={isEditMode} />
                    </div>
                    <div className="mt-2">
                        <div>Serever Name *</div>
                        <Autocomplete
                            freeSolo
                            className="common-autocomplete"
                            sx={MuiCss}
                            options={option?.server || []}
                            value={filterValues.server || null}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option?.server_name || ""
                            }
                            isOptionEqualToValue={(o, v) =>
                                o?.server_name === v?.server_name
                            }
                            filterOptions={(options, params) => {
                                const filtered = options.filter((option) =>
                                    option.server_name?.toLowerCase().includes(params.inputValue.toLowerCase())
                                );
                                const { inputValue } = params;
                                if (inputValue !== "" && !options.some((opt) => opt.server_name.toLowerCase() === inputValue.toLowerCase())) {
                                    filtered.push({ server_id: 0, server_name: inputValue, inputValue });
                                }
                                return filtered;
                            }}
                            onChange={(e, newValue) => {
                                if (!newValue) {
                                    setFilterValues(prev => ({ ...prev, server: null, server_local_ip: "", server_static_ip: "" }));
                                    return;
                                }
                                const name = typeof newValue === "string" ? newValue : newValue.inputValue || newValue.server_name;
                                const selectedServer = option.server?.find(s => s.server_name?.toLowerCase().trim() === name.toLowerCase().trim());
                                setFilterValues(prev => ({
                                    ...prev, server: { server_id: isEditMode ? prev.server?.server_id : 0, server_name: name },
                                    server_local_ip: selectedServer ? selectedServer.server_local_ip || "" : "",
                                    server_static_ip: selectedServer ? selectedServer.server_static_ip || "" : ""
                                }));
                            }}
                            renderOption={(props, option) => (
                                <li {...props} key={`${option.server_id}-${option.server_name}`}>
                                    {option.server_name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Server"
                                    onBlur={(e) => {
                                        const value = e.target.value?.trim();
                                        if (!value) return;
                                        setFilterValues((prev) => ({ ...prev, server: { server_id: isEditMode ? prev.server?.server_id : 0, server_name: value } }));
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-6">
                            <div>Server Local IP*</div>
                            <input
                                className="input-dd w-100 mt-2"
                                placeholder="Static IP"
                                value={filterValues.server_local_ip || ""}
                                disabled={!isEditMode && !!_.find(option.server || [], s => s.server_name?.toLowerCase() === filterValues?.server?.server_name?.toLowerCase())}
                                onChange={(e) => {
                                    setFilterValues(prev => ({ ...prev, server_local_ip: e.target.value }));
                                }}
                            />

                        </div>
                        <div className="col-md-6">
                            <div>Server Static IP*</div>
                            <input
                                className="input-dd w-100 mt-2"
                                placeholder="Static IP"
                                value={filterValues.server_static_ip || ""}
                                disabled={!isEditMode && !!_.find(option.server || [], s => s.server_name?.toLowerCase() === filterValues?.server?.server_name?.toLowerCase())}
                                onChange={(e) => {
                                    setFilterValues(prev => ({ ...prev, server_static_ip: e.target.value }));
                                }}
                            />

                        </div>
                    </div>
                    <div className="mt-3">
                        <div>Location*</div>
                        <input
                            className="input-dd w-100 mt-2"
                            placeholder="Location"
                            value={filterValues.location_name || ""}
                            onChange={(e) =>
                                setFilterValues((prev) => ({ ...prev, location_name: e.target.value }))
                            }
                        />
                    </div>
                    <div className="mt-3">
                        <div className="row align-items-center mb-2">
                            <div className="col-md-6">
                                <div>Database Name *</div>
                            </div>

                            <div className="col-md-3">
                                <div>Users *</div>
                            </div>

                            <div className="col-md-3 d-flex justify-content-end">
                                <button type="button" className="sk-btn-primary rounded" onClick={() => setDbInputs(prev => [...prev, { database_name: "", users: [] }])}>Add More  </button>
                            </div>
                        </div>

                        {dbInputs.map((row, index) => (
                            <div className="row mt-2" key={index}>
                                <div className="col-md-6">
                                    <input
                                        className="input-dd w-100 mt-2"
                                        placeholder={`Database ${index + 1}`}
                                        value={row.database_name || ""}
                                        onChange={(e) => {
                                            const updated = [...dbInputs];
                                            updated[index] = {
                                                ...updated[index],
                                                database_name: e.target.value
                                            };
                                            setDbInputs(updated);
                                        }}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <MultiSelect
                                        className="w-100 input-dd mt-2"
                                        options={option?.users || []}
                                        optionLabel="user_display_name"
                                        placeholder="Select Users"
                                        filter
                                        value={row.users || []}
                                        onChange={(e) => {
                                            const updated = [...dbInputs];
                                            updated[index] = {
                                                ...updated[index],
                                                users: e.value
                                            };
                                            setDbInputs(updated);
                                        }}
                                        filterInputAutoFocus
                                        panelHeaderTemplate={(options) => PanelHeaderTemplate(
                                            options,
                                            'users',
                                            row.users,
                                            (val) => {
                                                const updated = [...dbInputs];
                                                updated[index] = { ...updated[index], users: val };
                                                setDbInputs(updated);
                                            }
                                        )}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <button className="sk-btn-primary rounded" onClick={() => { resetForm(); setEnabelpopup(false) }}> Cancel</button>
                        <button className=" btn-primary rounded" onClick={() => { handleUpsertServerdata() }}>Submit</button>
                    </div>
                </Dialog>

                {loader ? (<SkeletonDataTable numSkeletons={20} />
                ) : (
                    <DataTable
                        value={rowData}
                        key={rowData.length}
                        rowGroupMode="rowspan"
                        groupRowsBy={["project_name","project_server_key"]}
                        sortMode="multiple"
                        sortField={["project_name","project_server_key"]}
                        scrollable
                        scrollHeight="80vh"
                        tableStyle={{ tableLayout: "fixed",maxWidth: "60%" }}
                    >
                        {columns.map(col => (
                            <Column
                                key={col.field}
                                field={col.field === "server_name" ? "project_server_key" : (col.field === "Actions" ? undefined : col.field)}
                                header={col.header}
                                style={{ textAlign: col.field === "Actions" ? "center" : "left", height: "40px"}}
                                body={(row) => {
                                    if (col.field === "project_name") {
                                        return row.project_name ?? "-";
                                    }
                                    if (col.field === "server_name") {
                                        return row.server_name ?? "-";
                                    }
                                    if (col.field === "database_name") {
                                        return row.database_name ?? "-";
                                    }
                                    if (col.field === "approver_user_codes") {
                                        return (
                                            <div className="text-truncate" title={row.approver_user_names || "-"} style={{ width: "100%"}}>{row.approver_user_names || "-"} </div>
                                        );
                                    }
                                    if (col.field === "Actions") {
                                        return (
                                            <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                                                <span onClick={() => handleEdit(row)}>
                                                    <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                                                </span>
                                                <span className="text-danger" onClick={() => handleDelete(row)}>
                                                    <FontAwesomeIcon icon="fa-solid fa-trash" />
                                                </span>
                                            </div>
                                        );
                                    }
                                    return row[col.field] ?? "-";
                                }}
                            />
                        ))}
                    </DataTable>
                )}
            </div>
        </div>

    );
};

export default ServerDatabase
